import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getSystemSettings = () => {
  return Helpers.get(Constants.SYSTEM_SETTINGS_URL);
};

export const updateSystemSettings = (id, data) => {
  const url = `${Constants.SYSTEM_SETTINGS_URL}/${id}`;
  return Helpers.put(url, {}, data);
};

export const getSystemSettingsConfig = () => {
  return Helpers.get(`${Constants.SYSTEM_SETTINGS_URL}/config`);
};
